
import React from 'react';
import './Footer.css';
import 'font-awesome/css/font-awesome.min.css';

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white mt-5 pt-4 pb-2 " >
      <div className="container">
        <div className="row">
          {/* <div className="col-md-4">
            <h5>Categories</h5>
            <ul className="list-unstyled">
              <li><a href="#men" className="footer-link">Men</a></li>
              <li><a href="#women" className="footer-link">Women</a></li>
              <li><a href="#electronics" className="footer-link">Electronics</a></li>
              <li><a href="#accessories" className="footer-link">Accessories</a></li>
            </ul>
          </div> */}
          <div className="col-md-4">
            <h5>Contact Us</h5>
            <p>Email: support@timelib.com</p>
            <p>Phone: +231 886 222 600</p>
          </div>
          <div className="col-md-4">
            <h5>Follow Us</h5>
            <ul className="list-inline">
              <li className="list-inline-item">
                <a href="https://web.facebook.com/foutalib" className="footer-link">
                  <i className="fa fa-facebook"></i> Facebook
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://wa.me/+231881389579" className="footer-link">
                  <i className="fa fa-whatsapp"></i> WhatsApp
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://www.tiktok.com/@foutalib4?_t=8rrDbhTGsVk&_r=1" className="footer-link">
                  <i className="fa fa-tiktok"></i> TikTok
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center mt-3">
          <p>&copy; 2024 TimeLib. All rights reserved.</p>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
